export default "__VITE_ASSET__rSXQogvx__"